//export default () =>   fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDpAMg5NRxeJMwvfoQOywr-vCwWvEUEeFQ', { method: 'POST' })  .then(response => response.json());

const location = () => {
    //const url = '/namaz-time/cities.json';
    const url = '/wp-content/uploads/cities.json';
    let citiesLoc = JSON.parse(localStorage.getItem('cities'));
    if (!(Array.isArray(citiesLoc) && citiesLoc.length > 1)) {
        fetch(url).then(cities => cities.json())
            .then(cities => { localStorage.setItem('cities', JSON.stringify(cities)); citiesLoc = cities;})
            .catch(err => console.error(err));
    }
    if (!(Array.isArray(citiesLoc) && citiesLoc.length)) {
        citiesLoc = [{"id":296,"city":"New Delhi","lat":28.7,"lng":77.2,"state":"Delhi"}];
        setTimeout(()=> { window.location.reload();}, 500);
    }

    return citiesLoc;
};

export default location;